import React from 'react';
import './StatNumber.less';

export const StatNumber = ({number = 0}) => {
	return <span className="stat-number">{number}</span>;
};
